module.exports = __webpack_public_path__ + "static/media/icon1.82b37e8a.svg";